import React from 'react';
import { useRemoteData } from '../../model/data';
import { getShop } from '../../model/shop';
import { t } from '../../locales/translate';

interface Props {
  id: string;
}

export function ShopName({ id }: Props): JSX.Element | null {
  const [shop, loading, error] = useRemoteData(
    async () => await getShop(id),
    (db) => db.table('shops').find(id)
  );

  if (loading) {
    return <span>{t.actions.loading('')}</span>;
  } else if (error || !shop) {
    return <span>{id}</span>;
  }
  return <span>{shop.name}</span>;
}
